import React, { useState, useEffect } from 'react';
import './CustomerDashboard.css';

function CustomerDashboard() {
  // State for customer dashboard data
  const [customerStats, setCustomerStats] = useState([
    { id: 1, title: "Upcoming Appointments", value: "3", icon: "📅", change: "2 this week", color: "#4F46E5", trend: "up" },
    { id: 2, title: "Total Bookings", value: "24", icon: "📋", change: "+8 this month", color: "#10B981", trend: "up" },
    { id: 3, title: "Loyalty Points", value: "1,250", icon: "⭐", change: "+150 today", color: "#F59E0B", trend: "up" },
    { id: 4, title: "Favorite Salons", value: "5", icon: "❤️", change: "Add more", color: "#EF4444", trend: "neutral" }
  ]);

  const [upcomingAppointments, setUpcomingAppointments] = useState([
    { id: 1, date: "Today", time: "3:00 PM", salon: "Glamour Salon", service: "Haircut & Styling", status: "confirmed", duration: 60, price: "$45" },
    { id: 2, date: "Tomorrow", time: "11:00 AM", salon: "Luxury Spa", service: "Full Body Massage", status: "confirmed", duration: 90, price: "$85" },
    { id: 3, date: "Dec 20", time: "2:30 PM", salon: "Nail Paradise", service: "Manicure & Pedicure", status: "pending", duration: 75, price: "$60" },
    { id: 4, date: "Dec 22", time: "10:00 AM", salon: "Urban Cuts", service: "Beard Trim", status: "confirmed", duration: 30, price: "$25" }
  ]);

  const [recentSalons, setRecentSalons] = useState([
    { id: 1, name: "Glamour Salon", rating: 4.8, location: "Downtown", lastVisit: "2 days ago", favorite: true, image: "🏪" },
    { id: 2, name: "Luxury Spa", rating: 4.9, location: "Uptown", lastVisit: "1 week ago", favorite: true, image: "💆" },
    { id: 3, name: "Urban Cuts", rating: 4.5, location: "Midtown", lastVisit: "3 days ago", favorite: false, image: "💈" },
    { id: 4, name: "Nail Paradise", rating: 4.7, location: "West End", lastVisit: "2 weeks ago", favorite: true, image: "💅" },
    { id: 5, name: "Classic Barbers", rating: 4.3, location: "East Side", lastVisit: "1 month ago", favorite: false, image: "✂️" }
  ]);

  const [recommendedServices, setRecommendedServices] = useState([
    { id: 1, name: "Hair Color Treatment", salon: "Glamour Salon", price: "$120", rating: 4.8, duration: "120 min", popular: true },
    { id: 2, name: "Hot Stone Massage", salon: "Luxury Spa", price: "$95", rating: 4.9, duration: "90 min", popular: true },
    { id: 3, name: "Gel Manicure", salon: "Nail Paradise", price: "$45", rating: 4.7, duration: "60 min", popular: false },
    { id: 4, name: "Professional Shave", salon: "Classic Barbers", price: "$35", rating: 4.5, duration: "45 min", popular: true }
  ]);

  const [spendingData, setSpendingData] = useState([
    { month: "Jul", amount: 320, category: "Hair" },
    { month: "Aug", amount: 280, category: "Spa" },
    { month: "Sep", amount: 450, category: "Hair" },
    { month: "Oct", amount: 380, category: "Nails" },
    { month: "Nov", amount: 520, category: "Spa" },
    { month: "Dec", amount: 420, category: "Hair" }
  ]);

  const [activeTab, setActiveTab] = useState("overview");
  const [showBookNow, setShowBookNow] = useState(true);

  // Get status color
  const getStatusColor = (status) => {
    const colors = {
      'confirmed': '#10B981',
      'pending': '#F59E0B',
      'cancelled': '#EF4444',
      'completed': '#6366F1'
    };
    return colors[status] || '#6B7280';
  };

  // Get status label
  const getStatusLabel = (status) => {
    const labels = {
      'confirmed': 'Confirmed',
      'pending': 'Pending',
      'cancelled': 'Cancelled',
      'completed': 'Completed'
    };
    return labels[status] || status;
  };

  // Calculate total spending
  const totalSpent = spendingData.reduce((sum, month) => sum + month.amount, 0);

  // Handle new booking
  const handleNewBooking = () => {
    alert("Book new appointment - Add your booking logic here!");
  };

  // Handle salon click
  const handleSalonClick = (salonId) => {
    alert(`Viewing salon ID: ${salonId}`);
  };

  // Toggle favorite
  const toggleFavorite = (salonId) => {
    setRecentSalons(salons => 
      salons.map(salon => 
        salon.id === salonId 
          ? { ...salon, favorite: !salon.favorite }
          : salon
      )
    );
  };

  // Handle service booking
  const handleServiceBook = (serviceId) => {
    alert(`Booking service ID: ${serviceId}`);
  };

  return (
    <div className="customer-dashboard-container">
      {/* CUSTOMER HEADER SECTION */}
      <div className="customer-dashboard-header">
        <div className="customer-header-content">
          <div className="customer-header-left">
            <h1 className="customer-title">👋 Welcome back, Dinesh Goud!</h1>
            <p className="customer-subtitle">Your personalized beauty & grooming experience</p>
            <div className="customer-welcome-message">
              <span className="welcome-icon">✨</span>
              <span className="welcome-text">
                You have {upcomingAppointments.filter(a => a.status === 'confirmed').length} upcoming appointments
              </span>
            </div>
          </div>
          <div className="customer-header-right">
            <div className="customer-actions">
              <button className="customer-action-btn primary" onClick={handleNewBooking}>
                <span className="action-icon">➕</span>
                Book Now
              </button>
              <button className="customer-action-btn secondary">
                <span className="action-icon">🔍</span>
                Find Salons
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* CUSTOMER STATS GRID */}
      <div className="customer-stats-section">
        <div className="customer-stats-grid">
          {customerStats.map(stat => (
            <div 
              key={stat.id} 
              className="customer-stat-card"
              style={{ 
                background: `linear-gradient(135deg, ${stat.color}15 0%, ${stat.color}25 100%)`,
                borderLeft: `4px solid ${stat.color}`
              }}
            >
              <div className="customer-stat-content">
                <div className="customer-stat-main">
                  <h3 className="customer-stat-value">{stat.value}</h3>
                  <p className="customer-stat-title">{stat.title}</p>
                </div>
                <div 
                  className="customer-stat-icon"
                  style={{ 
                    backgroundColor: `${stat.color}20`,
                    color: stat.color
                  }}
                >
                  {stat.icon}
                </div>
              </div>
              <div className="customer-stat-change">
                <span 
                  className={`change-indicator ${stat.trend}`}
                  style={{ color: stat.color }}
                >
                  {stat.trend === 'up' ? '↗' : stat.trend === 'down' ? '↘' : '→'} {stat.change}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* MAIN DASHBOARD CONTENT */}
      <div className="customer-main-content">
        {/* LEFT COLUMN */}
        <div className="customer-left-column">
          {/* Upcoming Appointments Card */}
          <div className="customer-card">
            <div className="customer-card-header">
              <div>
                <h2>Upcoming Appointments</h2>
                <p className="card-subtitle">Your scheduled bookings</p>
              </div>
              <button className="view-all-btn" onClick={() => alert("View all appointments")}>
                View All →
              </button>
            </div>

            <div className="appointments-list">
              {upcomingAppointments.map(appointment => (
                <div key={appointment.id} className="appointment-item">
                  <div className="appointment-date">
                    <div className="date-day">{appointment.date}</div>
                    <div className="date-time">{appointment.time}</div>
                  </div>
                  <div className="appointment-details">
                    <div className="appointment-main">
                      <h4>{appointment.salon}</h4>
                      <p className="appointment-service">{appointment.service}</p>
                    </div>
                    <div className="appointment-meta">
                      <span className="appointment-duration">{appointment.duration} min</span>
                      <span className="appointment-price">{appointment.price}</span>
                    </div>
                  </div>
                  <div className="appointment-status">
                    <span 
                      className="status-badge"
                      style={{
                        backgroundColor: `${getStatusColor(appointment.status)}15`,
                        color: getStatusColor(appointment.status),
                        border: `1px solid ${getStatusColor(appointment.status)}`
                      }}
                    >
                      {getStatusLabel(appointment.status)}
                    </span>
                    <button className="action-btn view-btn" onClick={() => handleSalonClick(appointment.id)}>
                      👁️
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Recent Salons Card */}
          <div className="customer-card">
            <div className="customer-card-header">
              <div>
                <h2>Recent Salons</h2>
                <p className="card-subtitle">Salons you've visited recently</p>
              </div>
              <div className="time-tabs">
                <button 
                  className={`time-tab ${activeTab === 'recent' ? 'active' : ''}`}
                  onClick={() => setActiveTab('recent')}
                >
                  Recent
                </button>
                <button 
                  className={`time-tab ${activeTab === 'favorites' ? 'active' : ''}`}
                  onClick={() => setActiveTab('favorites')}
                >
                  Favorites
                </button>
              </div>
            </div>

            <div className="salons-grid">
              {recentSalons
                .filter(salon => activeTab === 'favorites' ? salon.favorite : true)
                .map(salon => (
                  <div key={salon.id} className="salon-card">
                    <div className="salon-header">
                      <div className="salon-image">
                        {salon.image}
                      </div>
                      <div className="salon-info">
                        <h4>{salon.name}</h4>
                        <div className="salon-rating">
                          <span className="rating-star">⭐</span>
                          <span className="rating-value">{salon.rating}</span>
                          <span className="rating-count">(128)</span>
                        </div>
                        <p className="salon-location">📍 {salon.location}</p>
                      </div>
                      <button 
                        className={`favorite-btn ${salon.favorite ? 'active' : ''}`}
                        onClick={() => toggleFavorite(salon.id)}
                      >
                        {salon.favorite ? '❤️' : '🤍'}
                      </button>
                    </div>
                    <div className="salon-footer">
                      <span className="last-visit">Last visit: {salon.lastVisit}</span>
                      <button className="book-now-btn" onClick={() => handleSalonClick(salon.id)}>
                        Book Now
                      </button>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>

        {/* RIGHT COLUMN */}
        <div className="customer-right-column">
          {/* Spending Overview Card */}
          <div className="customer-card">
            <div className="customer-card-header">
              <div>
                <h2>Spending Overview</h2>
                <p className="card-subtitle">Monthly beauty expenses</p>
              </div>
              <div className="spending-total">
                <h3>${totalSpent}</h3>
                <span className="total-label">Total spent (6 months)</span>
              </div>
            </div>

            <div className="spending-chart">
              <div className="chart-bars">
                {spendingData.map((month, index) => {
                  const barHeight = (month.amount / 600) * 100;
                  const categoryColors = {
                    'Hair': '#4F46E5',
                    'Spa': '#10B981',
                    'Nails': '#F59E0B',
                    'Others': '#EF4444'
                  };
                  
                  return (
                    <div key={index} className="chart-column">
                      <div className="chart-bar-container">
                        <div 
                          className="chart-bar"
                          style={{ 
                            height: `${barHeight}%`,
                            backgroundColor: categoryColors[month.category] || '#6B7280'
                          }}
                          title={`$${month.amount} - ${month.category}`}
                        >
                          <span className="bar-value">${month.amount}</span>
                        </div>
                      </div>
                      <span className="chart-label">{month.month}</span>
                      <span className="chart-category">{month.category}</span>
                    </div>
                  );
                })}
              </div>
            </div>

            <div className="chart-legend">
              <div className="legend-item">
                <div className="legend-color" style={{ backgroundColor: '#4F46E5' }}></div>
                <span>Hair Services</span>
              </div>
              <div className="legend-item">
                <div className="legend-color" style={{ backgroundColor: '#10B981' }}></div>
                <span>Spa Treatments</span>
              </div>
              <div className="legend-item">
                <div className="legend-color" style={{ backgroundColor: '#F59E0B' }}></div>
                <span>Nail Services</span>
              </div>
            </div>
          </div>

          {/* Recommended Services Card */}
          <div className="customer-card">
            <div className="customer-card-header">
              <h2>Recommended For You</h2>
              <p className="card-subtitle">Based on your preferences</p>
            </div>

            <div className="services-list">
              {recommendedServices.map(service => (
                <div key={service.id} className="service-card">
                  <div className="service-header">
                    <div className="service-info">
                      <h4>{service.name}</h4>
                      <p className="service-salon">{service.salon}</p>
                    </div>
                    {service.popular && (
                      <span className="popular-badge">🔥 Popular</span>
                    )}
                  </div>
                  <div className="service-details">
                    <div className="service-meta">
                      <span className="service-rating">
                        ⭐ {service.rating} <span className="rating-text">Rating</span>
                      </span>
                      <span className="service-duration">⏱️ {service.duration}</span>
                    </div>
                    <div className="service-footer">
                      <div className="service-price">
                        <strong>{service.price}</strong>
                      </div>
                      <button 
                        className="book-service-btn"
                        onClick={() => handleServiceBook(service.id)}
                      >
                        Book Now
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Special Offers Card */}
          <div className="customer-card offers-card">
            <div className="customer-card-header">
              <h2>Special Offers</h2>
              <span className="offers-badge">3 Active</span>
            </div>

            <div className="offers-list">
              <div className="offer-item">
                <div className="offer-icon">🎁</div>
                <div className="offer-content">
                  <h5>20% Off First Booking</h5>
                  <p>New customers get 20% off on first service</p>
                  <span className="offer-expiry">Expires: Dec 31</span>
                </div>
                <button className="claim-btn">Claim</button>
              </div>
              
              <div className="offer-item">
                <div className="offer-icon">💎</div>
                <div className="offer-content">
                  <h5>Loyalty Bonus</h5>
                  <p>Get free service after 10 bookings</p>
                  <span className="offer-expiry">You have 7/10</span>
                </div>
                <button className="claim-btn disabled" disabled>In Progress</button>
              </div>
              
              <div className="offer-item">
                <div className="offer-icon">🎉</div>
                <div className="offer-content">
                  <h5>Referral Bonus</h5>
                  <p>Earn $10 for each friend you refer</p>
                  <span className="offer-expiry">No expiry</span>
                </div>
                <button className="claim-btn">Share</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Floating Action Button for Quick Booking */}
      {showBookNow && (
        <button className="customer-fab" onClick={handleNewBooking}>
          <span className="fab-icon">➕</span>
          <span className="fab-tooltip">Quick Book</span>
        </button>
      )}
    </div>
  );
}

export default CustomerDashboard;